module.exports = __webpack_public_path__ + "img/ep-0-dosis.88bcdf30.jpg";